<template>
  <div class="pick-date">
    <common-head title="预约号源" go="/appointment" />
    <van-calendar
      class="calendar"
      v-if="list.length"
      :default-date="workdayDate"
      :formatter="formatter"
      :min-date="minDate" 
      :max-date="maxDate"
      :show-title="false"
      :poppable="false"
      :show-confirm="false"
      @select="select"
    />

    <pick-time ref="pick" />

    <!-- <div class="my-button">
      <van-button 
        type="info" 
        round 
        :disabled="!workdayDate"
        @click="showTime"
      >
        选择接种时间段
      </van-button>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment'
import CommonHead from 'components/CommonHead'
import PickTime from './PickTime'
import getDays from 'utils/getDays'
import { fetchOverview, fetchTime } from 'api/appointment'

export default {
  components: {
    CommonHead,
    PickTime
  },
  data() {
    return {
      list: [],
      workdayDate: null,
      minDate: moment()['_d'],
      maxDate: moment().add(6, 'days')['_d']
    }
  },
  created() {
    this.getOverview()
  },
  methods: {
    // 获取号源情况
    getOverview() {
      const params = {
        povCode: this.$route.query.povCode,
        workdayDateList: getDays(7)
      }
      fetchOverview(params).then(res => {
        this.list = res.data
      })
    },
    // 获取接种时间段
    showTime() {
      const params = {
        povCode: this.$route.query.povCode,
        workdayDate: moment(this.workdayDate).format('YYYY-MM-DD')
      }
      fetchTime(params).then(res => {
        if (!res.data.length) {
          return this.$toast('暂无可接种时间段')
        }
        this.$refs.pick.open(moment(this.workdayDate).format('YYYY-MM-DD'), res.data)
      })
    },
    // 日历数据处理
    formatter(day) {
      const data = this.list.find(v => v.workdayDate == moment(day.date).format('YYYY-MM-DD'))
      if (data) {
        if (data.hasNumberSource) {
          day.bottomInfo = '有号'
        } else {
          day.bottomInfo = '约满'
          day.type = 'disabled'
        }
      }
      return day
    },
    select(date) {
      this.workdayDate = date
      this.showTime()
    }
  }
}
</script>

<style lang="less" scoped>
.calendar {
  height: calc(100vh - 97px);
}
.my-button {
  background: #fff !important;
}
</style>